// extracted by mini-css-extract-plugin
export default {"footer":"FormFooter_footer__g2GCK","rightButtons":"FormFooter_rightButtons__2BG9Q"};